import {Component, OnDestroy, OnInit} from '@angular/core';
import {ThemePalette} from "@angular/material/core";
import {
  Config,
  getConfig,
  getEditingBusinessUnit,
  getSelectedBusinessUnit,
  initialConfigState,
  initialThemeState, showNotesTab,
  Theme,
  toggleLoading,
  updateEditingBusinessUnit
} from "../../../redux";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {BusinessUnitService} from "../../services";
import {IBusinessUnit} from "../../models";
import {ToastrService} from "ngx-toastr";
import {INavItem} from "../../../../models";
import {Subscription} from "rxjs";
import {UtilService} from "../../../shared/services";
import {ApprovalsService} from "../../../approvals/services/approvals/approvals.service";
import {IApprovalRequest} from "../../../approvals/models";
import {toggleNavigating} from "../../../redux/stores/config/config.actions";
import {AppFade} from "../../../../animations/animations";
import { NotesService } from 'src/app/services';
import { DataService } from 'src/app/services/data/data.service';

@Component({
  selector: 'app-business-units-navigation',
  templateUrl: './business-units-navigation.component.html',
  styleUrls: ['./business-units-navigation.component.scss'],
  animations: [AppFade()],
})
export class BusinessUnitsNavigationComponent implements OnInit, OnDestroy {

  loading = false;
  animationState = false;

  readonly ISSUER_LINKS: INavItem[] = [
    {title: 'Information', link: 'information', enabled: true, hidden: false, icon: "", toolTip: ""},
    {title: 'Regulatory',  link: 'regulatory',  enabled: true, hidden: false, icon: "", toolTip: "" },
    {title: 'Entities', link: 'entities', enabled: true, hidden: false, icon: "", toolTip: ""},
    {title: 'Deals', link: 'deals', enabled: true, hidden: false, icon: "", toolTip: ""},
    {title: 'Employees', link: 'employees', enabled: true, hidden: false, icon: "", toolTip: ""},
    {title: 'KYC', link: 'kyc', enabled: true, hidden: false, icon: "", toolTip: ""}
  ];
  readonly INVESTOR_LINKS: INavItem[] = [
    {title: 'Information', link: 'information', enabled: true, hidden: false, icon: "", toolTip: ""},
    {title: 'Regulatory',  link: 'regulatory',  enabled: true, hidden: false, icon: "", toolTip: "" },
    {title: 'Entities', link: 'entities', enabled: true, hidden: false, icon: "", toolTip: ""},
    {title: 'Matched Deals', link: 'deals', enabled: true, hidden: false, icon: "", toolTip: ""},
    {title: 'Mandates', link: 'mandates', enabled: true, hidden: false, icon: "", toolTip: ""},
    {title: 'Employees', link: 'employees', enabled: true, hidden: false, icon: "", toolTip: ""},
    {title: 'KYC', link: 'kyc', enabled: true, hidden: false, icon: "", toolTip: ""}
  ];
  // readonly ADMIN_LINKS: INavItem[] = [
  //   {title: 'Information', link: 'information', enabled: true, hidden: false, icon: "", toolTip: ""},
  //   {
  //     title: 'Regulatory',
  //     link: 'regulatory',
  //     enabled: true,
  //     hidden: false,
  //     icon: "",
  //     toolTip: ""
  //   },
  //   {title: 'Deals', link: 'deals', enabled: true, hidden: false, icon: "", toolTip: ""},
  //   {title: 'Mandates', link: 'mandates', enabled: true, hidden: false, icon: "", toolTip: ""},
  //   {title: 'Employees', link: 'employees', enabled: true, hidden: false, icon: "", toolTip: ""},
  //   {title: 'KYC', link: 'kyc', enabled: true, hidden: false, icon: "", toolTip: ""}
  // ];
  links: INavItem[] = [];
  editingBusinessUnit: IBusinessUnit = {} as unknown as IBusinessUnit;
  theme: Theme = initialThemeState;

  constructor(
    private approvalService: ApprovalsService,
    private toastrService: ToastrService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store,
    public util: UtilService,
    private dataService: DataService,
    public notesService: NotesService
  ) {
  
  }

  ngOnInit(): void {
    this.animationState = true;

    var selectedBu = this.activatedRoute.snapshot.data['SelectedBusinessUnitResolver'];
    console.log("Initializing Business Unit Navigation Component with BU", selectedBu);


    // get BU
    if (!selectedBu) {
      this.toastrService.error("Unable to load business unit!", $localize`:@@companyName:Rondeivu`);
      this.router.navigate(['/' + this.dataService.getBuSlug() + '/business-units']).then(() => {});
      return;
    }

    this.editingBusinessUnit = selectedBu;
    
    switch (this.editingBusinessUnit.businessUnitType.toUpperCase()) {
      case 'INVESTOR':
        this.links = this.INVESTOR_LINKS;
        break;
      case 'ISSUER':
        this.links = this.ISSUER_LINKS;
        break;
      
      default:
        this.links = [];
    }
  }

  getApprovalPermission(): boolean {
    if (!!this.editingBusinessUnit.businessUnitType) {
      switch (this.editingBusinessUnit.businessUnitType.toUpperCase()) {
        case 'ISSUER':
          return this.util.hasPermission(this.util.Permission.CAN_EDIT_BU_APPROVALS_ISSUER);
        case 'INVESTOR':
          return this.util.hasPermission(this.util.Permission.CAN_EDIT_BU_APPROVALS_INVESTOR);
      }
    }
    return false;
  }

  ngOnDestroy() {
    this.store.dispatch(updateEditingBusinessUnit({businessUnit: {} as IBusinessUnit}));
    this.store.dispatch(showNotesTab({show: false}));

    // destroy the selected BUid
    this.dataService.setSelectedAdminBusinessUnit(null);
  }

  allowApproval() {
    if (!!this.editingBusinessUnit && !!this.editingBusinessUnit.businessUnitType) {
      return this.editingBusinessUnit.status === 'PENDING' && this.util.isAdmin();
    }
    return false;
  }

  /**
   * Approve a business unit
   * @param b business unit
   */
  approveBusinessUnit(b: any) {
    this.sendApproval("Business Unit Approved!", {id: b.businessUnitId, type: "businessunit", status: "APPROVED"});
  }

  /**
   * Decline a business unit
   * @param b business unit
   */
  declineBusinessUnit(b: any) {
    this.sendApproval("Business Unit Declined!", {id: b.businessUnitId, type: "businessunit", status: "DECLINED"});
  }

  private sendApproval(msg: string, payload: IApprovalRequest) {
    this.store.dispatch(toggleLoading({loading: true}));
    this.approvalService.addApproval(payload).subscribe({
      next: (res: { status: string }) => {
        this.editingBusinessUnit.status = res.status
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastrService.success(msg, $localize`:@@companyName:Rondeivu`);
      }, error: err => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastrService.error("Unable to add approval!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  navigate(obj: INavItem) {
    this.store.dispatch(toggleNavigating({navigating: true}));
    setTimeout(() => {
      this.router.navigate(['/' + this.dataService.getBuSlug() + '/business-units/' + this.editingBusinessUnit.businessUnitId + obj.link]).then(() => {
        this.store.dispatch(toggleNavigating({navigating: false}));
      });
    }, 300);
  }

  goBack() {
    this.store.dispatch(toggleNavigating({navigating: true}));
    this.router.navigate(['/', this.dataService.getBuSlug(), 'business-units']).then(() => {
      this.store.dispatch(toggleNavigating({navigating: false}));
    });
  }

}
